import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CircularProgress } from "@mui/material";
import { baseUrl } from "../../../../helper/urls";
import { useSelector } from "react-redux";
const AddCounselor = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    profileImage: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country_code: "",
    universityName: "",
    satActScore: "",
    majorCourse: "",
    interestedIn: "General Counseling",
    testimony: "",
    pricePerHour: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value, country) => {
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
      country_code: `+${country.dialCode}`,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${baseUrl}/api/counselors`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Counselor added successfully!");
        setTimeout(() => {
          navigate("/all-counselors");
        }, 2000);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      error.response?.data?.errors?.forEach((err) => {
        toast.error(err.msg);
        console.error(err.msg);
      });
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="card h-100 p-0 radius-12">
        <div className="row justify-content-center">
          <div className="col-xxl-12 col-xl-12 col-lg-12">
            <div className="card border">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* First Name */}
                    <div className="col-sm-6">
                      <label className="form-label">
                        First Name <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        placeholder="Enter First Name"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Last Name */}
                    <div className="col-sm-6">
                      <label className="form-label ">
                        Last Name <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        placeholder="Enter Last Name"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Email */}
                    <div className="col-sm-6">
                      <label className="form-label ">
                        Email <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Enter email address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Phone Input */}
                    <div className="col-sm-6">
                      <label htmlFor="phone" className="form-label">
                        Phone <span className="text-danger">*</span>
                      </label>
                      <div className="custom-phone-input-wrapper">
                        <PhoneInput
                          country={"us"}
                          value={formData.phone}
                          onChange={handlePhoneChange}
                          inputProps={{
                            required: true,
                            name: "phone",
                            className: "form-control radius-8",
                          }}
                        />
                      </div>
                    </div>

                    {/* University Name */}
                    <div className="col-sm-6">
                      <label className="form-label ">
                        University Name{" "}
                        <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="universityName"
                        placeholder="Enter University Name"
                        value={formData.universityName}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* SAT/ACT Score */}
                    <div className="col-sm-6">
                      <label className="form-label">
                        SAT/ACT Score <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="satActScore"
                        placeholder="Enter SAT/ACT Score"
                        value={formData.satActScore}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Major Course */}
                    <div className="col-sm-6">
                      <label className="form-label">Major Course</label>
                      <input
                        type="text"
                        className="form-control"
                        name="majorCourse"
                        placeholder="Enter major course"
                        value={formData.majorCourse}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    {/* Interested In */}
                    <div className="col-sm-6">
                      <label className="form-label ">
                        Interested In <span className="text-danger-600">*</span>
                      </label>
                      <select
                        name="interestedIn"
                        className="form-control"
                        value={formData.interestedIn}
                        onChange={handleChange}
                        required
                      >
                        <option value="General Counseling">
                          General Counseling
                        </option>
                        <option value="College Counseling">
                          College Counseling
                        </option>
                        <option value="Essay Counseling">
                          Essay Counseling
                        </option>
                        <option value="Essay Collage Counseling">
                          Essay + College Counseling
                        </option>
                        <option value="Essay General Counseling">
                          Essay + General Counseling
                        </option>
                        <option value="College Tour">College Tour</option>
                      </select>
                    </div>

                    {/* Submit */}
                    <div className="col-sm-12 mt-3">
                      {loading ? (
                        <button
                          className="btn btn-primary rounded-pill px-5 py-2"
                          type="submit"
                          disabled
                        >
                          <CircularProgress color="white" size={25} />
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary rounded-pill px-5 py-2"
                          type="submit"
                          style={{ height: "40px" }}
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .custom-phone-input-wrapper .form-control {
          width: 100% !important;
          height: 45px;
          font-size: 16px;
        }

        .custom-phone-input-wrapper .flag-dropdown {
          height: 100%;
          border-radius: 8px 0 0 8px;
        }

        @media (max-width: 768px) {
          .custom-phone-input-wrapper .form-control {
            height: 40px;
            font-size: 14px;
          }
        }

        @media (max-width: 576px) {
          .custom-phone-input-wrapper .form-control {
            height: 36px;
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
};

export default AddCounselor;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import { CircularProgress } from "@mui/material";
// import { baseUrl } from "../../../../helper/urls";

// const AddCounselor = ({ initialData, isEdit }) => {
//   const navigate = useNavigate();
//   const [wordCount, setWordCount] = useState(0);
//   const [loading, setLoading] = useState(false);
//   console.log(isEdit, initialData, ">>>>>>>>>>>>>>>>>>>>>");

//   const [formData, setFormData] = useState({
//     profileImage: "",
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     country_code: "",
//     universityName: "",
//     satActScore: "",
//     majorCourse: "",
//     interestedIn: "General Counseling",
//     testimony: "",
//     pricePerHour: "",
//   });
//   // const [formData, setFormData] = useState({
//   //   profileImage: "",
//   //   firstName: initialData?.firstName || "",
//   //   lastName: initialData?.lastName || "",
//   //   email: initialData?.email || "",
//   //   phone: initialData?.phone || "",
//   //   country_code: initialData?.country_code || "",
//   //   universityName: initialData?.universityName || "",
//   //   satActScore: initialData?.satActScore || "",
//   //   majorCourse: initialData?.majorCourse || "",
//   //   interestedIn: initialData?.interestedIn || "General Counseling",
//   //   testimony: initialData?.testimony || "",
//   //   pricePerHour: initialData?.price_per_hour || "",
//   // });
//   console.log(formData, ">>>>>formData>>>>>>>>>>>>>>>>");
//   useEffect(() => {
//     if (initialData) {
//       setFormData({
//         profileImage: initialData?.profileImage || "",
//         firstName: initialData?.firstName || "",
//         lastName: initialData?.lastName || "",
//         email: initialData?.email || "",
//         phone: initialData?.phone || "",
//         country_code: initialData?.country_code || "",
//         universityName: initialData?.universityName || "",
//         satActScore: initialData?.satActScore || "",
//         majorCourse: initialData?.majorCourse || "",
//         interestedIn: initialData?.interestedIn || "General Counseling",
//         testimony: initialData?.testimony || "",
//         pricePerHour: initialData?.price_per_hour || "",
//       });
//     }
//   }, [initialData]);
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "testimony") {
//       const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
//       setWordCount(wordCount);
//     }

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handlePhoneChange = (status, value, countryData) => {
//     const dialCode = `+${countryData.dialCode}`;
//     const phoneWithoutCode = value.replace(dialCode, "").trim();

//     setFormData((prevData) => ({
//       ...prevData,
//       phone: phoneWithoutCode,
//       country_code: dialCode,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const apiUrl = isEdit
//       ? `${baseUrl}/api/counselors/update/${initialData?.id}`
//       : `${baseUrl}/api/counselors/all`;

//     try {
//       const response = await axios({
//         method: isEdit ? "put" : "post",
//         url: apiUrl,
//         data: formData,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.status === 200 || response.status === 201) {
//         toast.success(
//           `${isEdit ? "Counselor updated" : "Counselor added"} successfully!`
//         );
//         setTimeout(() => {
//           navigate("/all-counselors");
//         }, 2000);
//         setLoading(false);
//       }
//     } catch (error) {
//       setLoading(false);

//       error.response?.data?.errors?.forEach((err) => {
//         toast.error(err.msg);
//         console.error(err.msg);
//       });
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={2000} />
//       <div className="card h-100 p-0 radius-12">
//         <div className="row justify-content-center">
//           <div className="col-xxl-12 col-xl-12 col-lg-12">
//             <div className="card border">
//               <div className="card-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="row">
//                     {/* First Name */}
//                     <div className="col-sm-6">
//                       <label className="form-label">
//                         First Name <span className="text-danger-600">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="firstName"
//                         placeholder="Enter First Name"
//                         value={formData.firstName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     {/* Last Name */}
//                     <div className="col-sm-6">
//                       <label className="form-label ">
//                         Last Name <span className="text-danger-600">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="lastName"
//                         placeholder="Enter Last Name"
//                         value={formData.lastName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     {/* Email */}
//                     <div className="col-sm-6">
//                       <label className="form-label ">
//                         Email <span className="text-danger-600">*</span>
//                       </label>
//                       <input
//                         type="email"
//                         className="form-control"
//                         name="email"
//                         placeholder="Enter email address"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     {/* Phone Input */}
//                     <div className="col-sm-6">
//                       <div className="mb-20 w-100">
//                         <label
//                           htmlFor="phone"
//                           className="form-label fw-semibold text-primary-light text-sm mb-8"
//                         >
//                           Phone <span className="text-danger-600">*</span>
//                         </label>
//                         <PhoneInput
//                           country={"us"}
//                           value={
//                             formData.country_code && formData.phone
//                               ? `${formData.country_code}${formData.phone}`
//                               : ""
//                           }
//                           onChange={(value, country) => {
//                             const dialCode = `+${country.dialCode}`;
//                             const phoneWithoutCode = value.replace(
//                               dialCode,
//                               ""
//                             );
//                             setFormData((prev) => ({
//                               ...prev,
//                               phone: phoneWithoutCode,
//                               country_code: dialCode,
//                             }));
//                           }}
//                           inputClass="form-control radius-8 w-100"
//                           containerClass="w-100"
//                           inputProps={{
//                             required: true,
//                             name: "phone",
//                           }}
//                         />
//                       </div>
//                     </div>

//                     {/* University Name */}
//                     <div className="col-sm-6">
//                       <label className="form-label ">
//                         University Name{" "}
//                         <span className="text-danger-600">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="universityName"
//                         placeholder="Enter University Name"
//                         value={formData.universityName}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     {/* SAT/ACT Score */}
//                     <div className="col-sm-6">
//                       <label className="form-label">
//                         SAT/ACT Score <span className="text-danger-600">*</span>
//                       </label>
//                       <input
//                         type="number"
//                         className="form-control"
//                         name="satActScore"
//                         placeholder="Enter SAT/ACT Score"
//                         value={formData.satActScore}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     {/* <div className="col-sm-6">
//                       <div className="mb-20">
//                         <label
//                           htmlFor="pricePerHour"
//                           className="form-label fw-semibold text-primary-light text-sm mb-8"
//                         >
//                           Price Per hour{" "}

//                         </label>
//                         <input
//                           // type="text"
//                           type="number"
//                           className="form-control radius-8"
//                           id="pricePerHour"
//                           name="pricePerHour"
//                           placeholder="Enter price per hour"
//                           value={formData.pricePerHour}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div> */}

//                     {/* Major Course */}
//                     <div className="col-sm-6">
//                       <label className="form-label">Major Course</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         name="majorCourse"
//                         placeholder="Enter major course"
//                         value={formData.majorCourse}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>

//                     {/* Interested In */}
//                     <div className="col-sm-6">
//                       <label className="form-label ">
//                         Interested In <span className="text-danger-600">*</span>
//                       </label>
//                       <select
//                         name="interestedIn"
//                         className="form-control"
//                         value={formData.interestedIn}
//                         onChange={handleChange}
//                         required
//                       >
//                         <option value="General Counseling">
//                           General Counseling
//                         </option>
//                         <option value="College Counseling">
//                           College Counseling
//                         </option>
//                         <option value="Essay Counseling">
//                           Essay Counseling
//                         </option>
//                         <option value="Essay Collage Counseling">
//                           Essay + College Counseling
//                         </option>
//                         <option value="Essay General Counseling">
//                           Essay + General Counseling
//                         </option>
//                         <option value="College Tour">College Tour</option>
//                       </select>
//                     </div>

//                     {/* <div className="col-sm-12">
//                       <label className="form-label">
//                         Testimony <span className="text-danger-600">*</span>
//                       </label>
//                       <textarea
//                         className="form-control"
//                         name="testimony"
//                         placeholder="Enter at least 200 words"
//                         rows="4"
//                         value={formData.testimony}
//                         onChange={handleChange}
//                         required
//                       ></textarea>
//                       <small className="form-text text-muted">
//                         {wordCount} / 200 words
//                       </small>
//                       {wordCount > 0 && wordCount < 200 && (
//                         <div className="text-danger">
//                           Please enter atleast 200 words.
//                         </div>
//                       )}
//                     </div> */}

//                     {/* Submit */}
//                     <div className="col-sm-12 mt-3">
//                       {loading ? (
//                         <button
//                           className="btn btn-primary rounded-pill px-5 py-2"
//                           type="submit"
//                           disabled
//                         >
//                           <CircularProgress color="white" size={25} />
//                         </button>
//                       ) : (
//                         <button
//                           className="btn btn-primary rounded-pill px-5 py-2"
//                           type="submit"
//                           style={{ height: "40px" }}
//                         >
//                           {isEdit ? "Update" : "Save"}
//                         </button>
//                       )}
//                       {/* <button
//                         className="btn btn-primary rounded-pill px-5 py-2"
//                         type="submit"
//                       >
//                         {isEdit ? "Update" : "Save"}
//                       </button> */}
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AddCounselor;
